import type {
  BlackAndWhitePlayer,
  BlackAndWhiteState,
  InitGameOptions,
} from "./types";
import { BLACK_AND_WHITE_TILE_NUMBERS } from "./types";
import { getOtherPlayerId } from "./utils";

function createPlayer(playerId: string): BlackAndWhitePlayer {
  return {
    playerId,
    score: 0,
    remainingTiles: BLACK_AND_WHITE_TILE_NUMBERS,
    usedTiles: [],
  };
}

export function initGame(options: InitGameOptions): BlackAndWhiteState {
  const playerIds = [...new Set(options.playerIds)];
  if (playerIds.length !== 2) {
    throw new Error("Black and White requires exactly two players");
  }
  if (!playerIds.includes(options.hostPlayerId)) {
    throw new Error("Host must be one of the players");
  }

  const firstPlayerId = options.firstPlayerId ?? options.hostPlayerId;
  if (!playerIds.includes(firstPlayerId)) {
    throw new Error("First player must be one of the players");
  }

  return {
    gameId: options.gameId ?? `black-and-white-${playerIds.join("-")}`,
    hostPlayerId: options.hostPlayerId,
    observerGodViewEnabled: options.observerGodViewEnabled === true,
    status: "IN_PROGRESS",
    players: playerIds.map(createPlayer),
    completedRounds: [],
    currentRound: {
      roundNumber: 1,
      phase: "FIRST_SELECTION",
      firstPlayerId,
      secondPlayerId: getOtherPlayerId(playerIds, firstPlayerId),
      firstSubmission: null,
    },
    winnerId: null,
    maxRounds: 9,
    targetScore: 5,
  };
}
